import React, { useRef, useEffect } from "react";
import Webcam from "react-webcam";
import { CameraToggleButton } from "../../components";
import "./Preview.css";

const Preview = ({
  mode,
  showPreview,
  image,
  isRecording,
  transcript,
  webcamRef,
  touchPosition,
  updateTouchPosition,
  gravityDirection,
  videoConstraints,
  onCameraToggle,
}) => {
  const touchCanvasRef = useRef(null);

  // Handle touch/mouse events on canvas
  useEffect(() => {
    if (mode === "touch" && touchCanvasRef.current) {
      const canvas = touchCanvasRef.current;

      const handleMove = (e) => {
        e.preventDefault();
        const rect = canvas.getBoundingClientRect();
        // Get event position (works for both touch and mouse)
        const clientX = e.clientX || (e.touches && e.touches[0].clientX);
        const clientY = e.clientY || (e.touches && e.touches[0].clientY);

        if (clientX && clientY) {
          // Normalize coordinates (0-1)
          const normalizedX = (clientX - rect.left) / rect.width;
          const normalizedY = 1 - (clientY - rect.top) / rect.height;

          // Update cursor position and send to parent component
          updateTouchPosition({ x: normalizedX, y: normalizedY });
        }
      };

      // Add mouse and touch event listeners
      canvas.addEventListener("mousemove", handleMove);
      canvas.addEventListener("touchmove", handleMove);

      return () => {
        // Clean up event listeners
        canvas.removeEventListener("mousemove", handleMove);
        canvas.removeEventListener("touchmove", handleMove);
      };
    }
  }, [mode, updateTouchPosition]);

  return (
    <div className="preview-area">
      <div className="preview-container">
        {/* Camera Content */}
        {mode === "camera" && (
          <div className="camera-content">
            {/* Only show webcam when not showing captured image */}
            {!showPreview && (
              <>
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  videoConstraints={{ facingMode: videoConstraints }}
                />

                <CameraToggleButton
                  facingMode={videoConstraints}
                  onToggle={onCameraToggle}
                  isVisible={!showPreview}
                />
              </>
            )}

            {/* Show full screen image when in preview mode */}
            {showPreview && image && (
              <div className="full-image-preview">
                <img src={image} alt="Captured" />
              </div>
            )}
          </div>
        )}

        {/* Audio Content */}
        {mode === "audio" && (
          <div className="audio-content">
            {/* Text preview area */}
            <div className="transcript-box">
              {showPreview && transcript ? (
                <div className="transcript-text">{transcript}</div>
              ) : (
                <span className="placeholder-text">
                  {isRecording ? "Listening..." : "Tap to start speaking..."}
                </span>
              )}
            </div>
          </div>
        )}

        {/* Touch Canvas */}
        {mode === "touch" && (
          <div className="touch-content">
            <div className="canvas-container" ref={touchCanvasRef}>
              {/* Hand cursor */}
              {touchPosition && (
                <div
                  className="hand-cursor"
                  style={{
                    left: `${touchPosition.x * 100}%`,
                    top: `${(1 - touchPosition.y) * 100}%`,
                  }}
                ></div>
              )}

              {/* Instructions */}
              <div className="touch-instructions">
                {/* <p>Touch and move to control fluid particles</p> */}
                <p>
                  {/* Press button to toggle gravity: */}
                  <span className="gravity-direction">
                    {/* {gravityDirection === "up" ? " ↑ UP" : " ↓ DOWN"} */}
                  </span>
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Preview;
